export default __webpack_public_path__ + "static/media/thrift_savings_plan_dark.6d015717.png";